import { ErrorMessage } from '@Components';
import { useFetchData } from '@CustomHooks';
import { bopsApi } from '@Network';
import AskBops from './askBops';

const AskBopsContainer = () => {
  const { data, isLoading, error } = useFetchData<{ embedUrl: string; agentId: string }>(bopsApi.getAmazonQEmbedded);

  if (error) {
    const status = (error as { response?: { status?: number } })?.response?.status;
    const message = (error as { message?: string })?.message ?? 'Unknown error';
    return <ErrorMessage internalMessage={`Error loading Amazon Q (status ${status ?? 'n/a'}): ${message}`} />;
  }
  if (isLoading) return null;
  if (!data) return <ErrorMessage internalMessage="Amazon Q is not configured for this client (missing Chat Agent)" />;

  return <AskBops embedUrl={data.embedUrl} agentId={data.agentId} />;
};

export default AskBopsContainer;
